module.exports = __webpack_public_path__ + "img/fengcai1.6ff6c23c.png";